<script lang="ts" setup>
import AdkButton from '@components/ui/AdkButton.vue'
import { ConfirmDialogProps } from '@lib/models/modals'
import { onMounted } from 'vue'
import BaseDialog from './BaseDialog.vue'
import { useGtm } from '@composables/useGtm'
import { useDialogTransition } from '@composables/useDialogTransition'

const props = defineProps<ConfirmDialogProps>()

const emit = defineEmits<{
  confirm: []
  cancel: []
}>()

const { shown, closeDialog } = useDialogTransition()

const { trackPageView } = useGtm()

onMounted(() => {
  if (props.contentGroup) {
    trackPageView(props.contentGroup, true)
  }
})

const doAction = async (action: 'confirm' | 'cancel') => {
  await closeDialog()
  if (action === 'confirm') emit('confirm')
  else emit('cancel')
}
</script>

<template>
  <BaseDialog>
    <div
      v-if="shown"
      data-test="confirm-dialog"
      class="w-full h-full fixed top-0 left-0 z-10 bg-white flex flex-col justify-center"
      :class="customClass"
    >
      <section class="flex flex-col items-center gap-[calc(88*var(--vh))] pb-32">
        <div class="flex flex-col w-[78.98vw] gap-vh-56 items-center">
          <img
            class="h-[calc(144*var(--vh))] w-[calc(144*var(--vw))]"
            :src="imageUrl ?? `images/navigation/warning.svg`"
            :alt="title"
          />
          <div class="flex flex-col gap-vh-24 text-center">
            <h1 data-test="confirm-dialog_title" class="text-h1 font-bold">
              {{ title }}
            </h1>
            <p data-test="confirm-dialog_description" class="text-h3">
              {{ description }}
            </p>
          </div>
        </div>
        <div class="flex gap-vw-24">
          <AdkButton
            v-if="secondaryButton"
            class="w-[34.81vw]"
            size="large"
            @press="doAction('cancel')"
            >{{ secondaryButton }}</AdkButton
          >
          <AdkButton
            v-if="primaryButton"
            class="w-[34.81vw]"
            size="large"
            is-primary
            @press="doAction('confirm')"
            >{{ primaryButton }}</AdkButton
          >
        </div>
      </section>
    </div>
  </BaseDialog>
</template>
